import { graphql } from "../generated"

export const XmlFileProcessingStatusSubscription = graphql(`
  subscription XmlProcessingStatus($xmlInputId: String!) {
    onXmlFileProcessed(xmlInputId: $xmlInputId) {
      errorMessages
      fileName
      requestType
      status
      b2gPayload
      responseId
      xmlInputId
    }
  }
`)
